class ProductAccordionDescription {
  setupListeners () {
    const readMore = document.querySelector('[href="#productDescription"]')
    if (!readMore) return

    this.accordionDescription = document.querySelector('#productAccordionAbout')
    if (!this.accordionDescription) {
      readMore.style.display = 'none'
      return
    }

    readMore.addEventListener('click', () => this.slideToDescription())
  }

  slideToDescription () {
    const parent = this.accordionDescription.parentElement

    window.scrollTo({
      top: this.accordionDescription.offsetTop,
      left: 0,
    })

    if (parent.getAttribute('aria-expanded') !== 'true') {
      this.accordionDescription.click()
    }
  }
}

new ProductAccordionDescription().setupListeners()
